import { createSlice } from '@reduxjs/toolkit';
import { OMSPROFILE } from '../../../API';
import { logFrontendActivity } from '../../General/activityLogger';

export const passwordslice = createSlice({
    name: 'password',
    initialState: {
        loading: false,
        status: null,
        message: "", 
        hasErrors: false,      
    },
    reducers: {       
        putPassword: (state) => {
            return {
                ...state,
                loading: true
            }
        },
        putPasswordSuccess: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: false, 
                message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message
            }
        },
        putPasswordFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message
            }
        },

    }
})
export const { putPassword,
    putPasswordSuccess, putPasswordFailure } = passwordslice.actions;


export const updatePassword = (userid,data) => {

    return (dispatch) => {

        dispatch(putPassword());
        const logRef = crypto.randomUUID();
        try {
            OMSPROFILE.patch('/changepassword/1', data, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
                .then(function (response) {
                    dispatch(putPasswordSuccess(response));
                    logFrontendActivity({
                        group: 'SETTINGS',
                        subgroup: 'PASSWORD_UPDATE',
                        action: 'SUCCESS',
                        request_data: data,
                        response_data: response.data,
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }else{
                            console.log('Activity log failed:', ref);
                        }
                    });               
                }).catch(function (error) {
                    dispatch(putPasswordFailure(error.response));
                    logFrontendActivity({
                        group: 'SETTINGS',
                        subgroup: 'PASSWORD_UPDATE',
                        action: 'FAILURE',
                        request_data: data,
                        response_data: error.response?.data || {},
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }
                    });                
                })
        }
        catch (error) {
            dispatch(putPasswordFailure(error.response));
            logFrontendActivity({
                group: 'SETTINGS',
                subgroup: 'PASSWORD_UPDATE',
                action: 'FAILURE',
                request_data: data,
                response_data: error.response?.data || {},
                log_ref: logRef,
                userid: userid
            }).then((ref) => {
                if (ref) {
                    console.log('Activity log recorded with log_ref:', ref);
                }
            }); 
        }

    }
}

export default passwordslice.reducer;
